// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NQLT","title":"styles_title__2Hu9F"};